import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    underDevelopment: {
        id: "languages.underDevelopment",
    },
});

export default messages;
